// eslint-disable-next-line import/no-extraneous-dependencies
import { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import Authorization from '@/pages/auth/Authorization'
import PublicPageLayout from '@/pages/layouts/PublicPageLayout'
import Register from '@/pages/auth/Register'
import ResetPassword from '@/pages/auth/ResetPassword'
import ResetPasswordEmail from '@/pages/auth/ResetPasswordEmail'
import Login from '@/pages/auth/Login'
import PageNotFound from '@/pages/PageNotFound'

function App() {
  return (
    <PublicPageLayout>
      <Authorization>
        <Suspense fallback={<div>Loading...</div>}>
          <Outlet />
        </Suspense>
      </Authorization>
    </PublicPageLayout>
  )
}

export const publicRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <Navigate to="/login" replace />
      },
      {
        path: '/login',
        element: <Login />
      },
      {
        path: '/reset-password',
        element: <ResetPasswordEmail />
      },
      {
        path: '/register/:token',
        element: <Register />
      },
      {
        path: '/reset-password/:token',
        element: <ResetPassword />
      }
    ]
  },
  { path: '/not-found', element: <PageNotFound /> },
  { path: '*', element: <Navigate to="/not-found" replace /> }
]
